module.exports = __webpack_public_path__ + "assets/63d537fb0803f09029dd8cebf1e2ac82.png";